import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function HomeView() {
    const { t } = useTranslation();

    return (
        <div className="flex w-full flex-col items-center text-center text-white">
            <section className="space-y-4 animate-fade-in">
                <p className="text-xs uppercase tracking-[0.4em] text-white/70">{t('route.home.txtHeroKicker')}</p>
                <h1 className="text-3xl font-semibold leading-tight text-white md:text-5xl">{t('route.home.txtHeroTitle')}</h1>
                <p className="mx-auto max-w-2xl text-base text-white/80 md:text-lg">{t('route.home.txtHeroSubtitle')}</p>
            </section>

            <section className="mt-10 w-full max-w-2xl">
                <Outlet />
            </section>
        </div>
    );
}
